export function highlightPattern(text, pattern) {
    if(!pattern) return text;
    return text.replace(new RegExp(pattern, 'ig'), (value) => `<mark>${value}</mark>`);
}